import { render, staticRenderFns } from "./BackofficeAutorizacaoNegociacaoParticular.vue?vue&type=template&id=e8b99afc&scoped=true"
import script from "./BackofficeAutorizacaoNegociacaoParticular.vue?vue&type=script&lang=ts"
export * from "./BackofficeAutorizacaoNegociacaoParticular.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeAutorizacaoNegociacaoParticular.vue?vue&type=style&index=0&id=e8b99afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b99afc",
  null
  
)

export default component.exports